const ANDROID_PACKAGE = "com.matchstars.royalsmash";
// App Store numeric id (from App Store Connect → App Information). Empty until
// the app exists there; the native SKStoreReviewController path needs no id.
const IOS_APP_STORE_ID = "6789154721";

function getNativePlugin(): { requestReview: () => Promise<void> } | null
{
  const plugin = ( window as any ).Capacitor?.Plugins?.InAppReview;

  if ( plugin && typeof plugin.requestReview === "function" )
    return plugin;

  return null;
}

function getPlatform(): string
{
  const cap = ( window as any ).Capacitor?.getPlatform?.();
  if ( cap === "android" || cap === "ios" )
    return cap;

  return "web";
}

function openPlayStore(): void
{
  try
  {
    window.open( `market://details?id=${ANDROID_PACKAGE}&showAllReviews=true`, "_system" );
  }
  catch
  {
    window.open( `https://play.google.com/store/apps/details?id=${ANDROID_PACKAGE}`, "_blank" );
  }
}

function openAppStore(): void
{
  if ( !IOS_APP_STORE_ID ) return;
  try
  {
    window.open( `itms-apps://apps.apple.com/app/id${IOS_APP_STORE_ID}?action=write-review`, "_system" );
  }
  catch
  {
    window.open( `https://apps.apple.com/app/id${IOS_APP_STORE_ID}?action=write-review`, "_blank" );
  }
}

function openStore( platform: string ): void
{
  if ( platform === "ios" ) openAppStore();
  else openPlayStore();
}

export const InAppReviewPlugin = {
  async requestReviewWithFallback(): Promise<void>
  {
    const platform = getPlatform();

    if ( platform === "web" )
    {
      openPlayStore();
      return;
    }

    const native = getNativePlugin();

    if ( !native )
    {
      openStore( platform );
      return;
    }

    // iOS decides itself whether SKStoreReviewController shows anything (at
    // most three prompts a year), and nothing observable happens when it
    // declines, so the fallback timer only applies to Android.
    if ( platform === "ios" )
    {
      try { await native.requestReview(); }
      catch { openAppStore(); }
      return;
    }

    try
    {
      let review_dialog_shown = false;
      let timeout_id: number | null = null;

      const pause_listener = () =>
      {
        review_dialog_shown = true;

        if ( timeout_id !== null )
        {
          clearTimeout( timeout_id );
          timeout_id = null;
        }
      };

      document.addEventListener( "pause", pause_listener );

      await native.requestReview();

      timeout_id = window.setTimeout( () =>
      {
        document.removeEventListener( "pause", pause_listener );

        if ( !review_dialog_shown )
          openPlayStore();
      }, 2500 );
    }
    catch
    {
      openPlayStore();
    }
  },
};
